import { render } from "./QuickFilters.vue?vue&type=template&id=ae846ff8&scoped=true"
import script from "./QuickFilters.vue?vue&type=script&lang=js"
export * from "./QuickFilters.vue?vue&type=script&lang=js"

import "./QuickFilters.vue?vue&type=style&index=0&id=ae846ff8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ae846ff8"

export default script